import Types from "./types";

const fetchCachePagesBegin = () => ({
  type: Types.FETCH_CACHEPAGES_BEGIN,
});

const fetchCachePagesSuccess = (payload) => ({
  type: Types.FETCH_CACHEPAGES_SUCCESS,
  payload,
});

const fetchCachePagesError = (error) => ({
  type: Types.FETCH_CACHEPAGES_ERROR,
  error,
});

const setCachePagesFilters = (payload) => ({
  type: Types.SET_CACHEPAGES_FILTERS,
  payload,
});

const updateCachePagesBegin=()=>({
  type: Types.UPDATE_CACHEPAGES_BEGIN,
});

const updateCachePagesSuccess=(payload)=>({
  type: Types.UPDATE_CACHEPAGES_SUCCESS,
  payload,
});

const updateCachePagesError=(error)=>({
  type: Types.UPDATE_CACHEPAGES_ERROR,
  error,
});
export default {
  fetchCachePagesBegin,
  fetchCachePagesSuccess,
  fetchCachePagesError,
  setCachePagesFilters,
  updateCachePagesBegin,
  updateCachePagesSuccess,
  updateCachePagesError,
};
